document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('news-filters');
  if (!form) return;

  const regionSelect = form.querySelector('[name="region"]');
  const categorySelect = form.querySelector('[name="news_category"]');
  const searchInput = form.querySelector('[name="keyword-s"]');

  if (window.jQuery) {
    jQuery(regionSelect).on('select2:select select2:clear', function () {
      form.submit()
    });
    jQuery(categorySelect).on('select2:select select2:clear', function () {
      form.submit()
    });
  }

  /* Fallback for non-Select2 selects */
  regionSelect?.addEventListener('change', function () {
    form.submit();
  });
  categorySelect?.addEventListener('change', function () {
    form.submit();
  });

  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      form.submit();
    }
  });
});